import * as React from 'react';

import {ChevronBorder} from '../../lead/shared/components';

import styles from './visual-pipeline-column-header.module.css';

export class VisualPipelineColumnHeaderPlaceholder extends React.PureComponent<{
    isLastChild: boolean;
    zIndex: number;
}> {
    render() {
        return (
            <div style={{zIndex: this.props.zIndex}} className={styles.container}>
                {!this.props.isLastChild ? <ChevronBorder side='right' /> : undefined}
            </div>
        );
    }
}
